/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsForRegex": ["^draft"] }] */
import { produce } from 'immer';

import AUTH_ACTION_TYPES, {
  LoginViaQrActionTypes,
  SSOLoginActionTypes,
} from 'actionTypes/auth';
import USER from 'actionTypes/user';
import { API_STATUS } from 'constants/enums';
import { Auth, LoginViaQrTokenStatus } from 'types/Auth';

import INITIAL_STATE from './initialstate/auth';

// eslint-disable-next-line consistent-return
const auth = produce((draft: Auth, action) => {
  switch (action.type) {
    case LoginViaQrActionTypes.REFRESH_TOKEN: {
      draft.login.viaQr = INITIAL_STATE.login.viaQr;

      break;
    }

    case AUTH_ACTION_TYPES[LoginViaQrActionTypes.CREATE_TOKEN]?.SUCCESS: {
      const { result } = action.result;

      draft.login.viaQr = {
        status: LoginViaQrTokenStatus.LOADED,
        expiryAt: result.expires_at,
        value: result.token,
      };
      break;
    }

    case LoginViaQrActionTypes.SET_QR_TOKEN_STATUS: {
      draft.login.viaQr.status = action.payload;
      break;
    }

    // Freshdesk sso
    case AUTH_ACTION_TYPES[SSOLoginActionTypes.AUTHORIZE_FRESKDESK]?.LOAD: {
      draft.ssoLogin.freskDeskAPIStatus = API_STATUS.LOADING;
      break;
    }

    case AUTH_ACTION_TYPES[SSOLoginActionTypes.AUTHORIZE_FRESKDESK]?.FAIL: {
      draft.ssoLogin.freskDeskAPIStatus = API_STATUS.ERROR;
      break;
    }

    case AUTH_ACTION_TYPES[SSOLoginActionTypes.AUTHORIZE_FRESKDESK]?.SUCCESS: {
      draft.ssoLogin.freskDeskAPIStatus = API_STATUS.SUCCESS;
      draft.ssoLogin.redirectURI = action.result.result.redirection_url;
      break;
    }

    // Third party sso login
    case AUTH_ACTION_TYPES[SSOLoginActionTypes.GET_CLIENT_INFO]?.LOAD: {
      draft.ssoLogin.thirdPartyFetchAPIStatus = API_STATUS.LOADING;
      break;
    }

    case AUTH_ACTION_TYPES[SSOLoginActionTypes.GET_CLIENT_INFO]?.FAIL: {
      draft.ssoLogin.thirdPartyFetchAPIStatus = API_STATUS.ERROR;
      break;
    }

    case AUTH_ACTION_TYPES[SSOLoginActionTypes.GET_CLIENT_INFO]?.SUCCESS: {
      draft.ssoLogin.thirdPartyFetchAPIStatus = API_STATUS.SUCCESS;
      draft.ssoLogin.clientInfo.name = action.result.name;
      draft.ssoLogin.clientInfo.logo = action.result.logo;
      break;
    }

    case AUTH_ACTION_TYPES[SSOLoginActionTypes.CONFIRM_SSO_LOGIN]?.LOAD: {
      draft.ssoLogin.thirdPartyConfirmAPIStatus = API_STATUS.LOADING;
      break;
    }

    case AUTH_ACTION_TYPES[SSOLoginActionTypes.CONFIRM_SSO_LOGIN]?.FAIL: {
      draft.ssoLogin.thirdPartyConfirmAPIStatus = API_STATUS.ERROR;
      break;
    }

    case AUTH_ACTION_TYPES[SSOLoginActionTypes.CONFIRM_SSO_LOGIN]?.SUCCESS: {
      draft.ssoLogin.thirdPartyConfirmAPIStatus = API_STATUS.SUCCESS;
      draft.ssoLogin.thirdPartyAuthData.redirect = action.result.redirect;
      draft.ssoLogin.thirdPartyAuthData.state = action.result.state;
      draft.ssoLogin.thirdPartyAuthData.uri = action.result.uri;
      draft.ssoLogin.thirdPartyAuthData.auth_code = action.result.auth_code;
      break;
    }

    case USER.LOGOUT.SUCCESS: {
      return INITIAL_STATE;
    }

    default:
      break;
  }
}, INITIAL_STATE);

export default auth;
